import * as React from "react";
import { singleton } from "logic/singleton";
const DisableSubmissionStateContext = React.createContext({
  disabled: false,
  setDisabled: () => {
  }
});
export default singleton("contexts.DisableSubmissionState", () => DisableSubmissionStateContext);
